export const apiConstants = {
  url: "/api/location"
};
